// extracted by mini-css-extract-plugin
export default {"report-page":"ReportPage_report-page__obVVV","overlay":"ReportPage_overlay__lzyMC","loader":"ReportPage_loader__dqOIf"};